import { connect } from "react-redux";

import { PathUtils } from "../../../Engine/Core/PathUtils/PathUtils";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withExternalMountingEventReporting } from "../../Services/ExternalMountingEventReporting/withExternalMountingEventReporting";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { Text } from "./Text";

export interface TextContainerProps {
    bindingPath: AbsoluteModelPath;
    valueName?: string;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: TextContainerProps) => {
    const { bindingPath, valueName = "value", viewModelSelect } = ownProps;

    const controlModel = viewModelSelect.controlModel(state, bindingPath);
    if (valueName === "value") {
        return {
            value: controlModel.value,
            isTooltipEnabled: controlModel.isTooltipEnabled,
            error: controlModel.error,
            warning: controlModel.warning,
            isReadOnly: state.settings.isReadOnly,
        };
    } else if (PathUtils.isPicklistFieldValueName(valueName)) {
        return {
            value: viewModelSelect.customFieldValue(state, bindingPath, valueName),
            isTooltipEnabled: controlModel.isTooltipEnabled,
            error: controlModel.error,
            warning: controlModel.warning,
            isReadOnly: state.settings.isReadOnly,
        };
    } else {
        return {
            value: viewModelSelect.customFieldValue(state, bindingPath, valueName),
            isTooltipEnabled: controlModel.isTooltipEnabled,
            isReadOnly: state.settings.isReadOnly,
        };
    }
};

export const TextContainer = withResolvePaths(
    withViewModelSelect(
        connect(mapStateToProps)(
            withFocusManagement(
                withExternalMountingEventReporting(withTestPageObjectRegistration(withControlDebugInfo(Text)))
            )
        )
    )
);
